import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconName", "className"];
import React, { useEffect, useState } from 'react';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _isEmpty from 'lodash/isEmpty';
import { iconLibraries } from './Icon.constants';
import { getLibraryFromIconName, initializeFontAwesomeLibrary, getFontAwesomeIcon, getFishermanIcon } from './Icon.utils';
import { classNames } from '../../../../utils/classname';
import useSemanticUiProps from '../../hooks/use-semantic-ui-props/use-semantic-ui-props';
import './Icon.less';
var defaultProps = {
  className: ''
};
var initialized = false;
export default function Icon(_ref) {
  var _classNames;
  var iconName = _ref.iconName,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useSemanticUiProps = useSemanticUiProps(rest),
    getIconProps = _useSemanticUiProps.getIconProps;
  var _useState = useState(initialized),
    _useState2 = _slicedToArray(_useState, 2),
    fontAwesomeInitialized = _useState2[0],
    setFontAwesomeInitialized = _useState2[1];
  useEffect(function () {
    if (!initialized) {
      initializeFontAwesomeLibrary();
      initialized = true;
    }
    var timer = setTimeout(function () {
      return setFontAwesomeInitialized(true);
    }, 500);
    return function () {
      clearTimeout(timer);
    };
  }, []);
  if (!fontAwesomeInitialized) {
    return null;
  }
  if (_isEmpty(iconName)) {
    return null;
  }
  var library = getLibraryFromIconName(iconName);
  var iconProps = getIconProps(rest);
  var finalClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, true), _defineProperty(_classNames, 'font-awesome', library === iconLibraries.FontAwesome), _defineProperty(_classNames, "fisherman", library === iconLibraries.Fisherman), _classNames));
  if (library === iconLibraries.SemanticUI) {
    return /*#__PURE__*/React.createElement(SemanticIcon, _extends({
      className: finalClassName,
      name: iconName
    }, iconProps));
  }
  if (library === iconLibraries.FontAwesome) {
    return /*#__PURE__*/React.createElement(SemanticIcon, _extends({
      className: finalClassName
    }, iconProps), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: getFontAwesomeIcon(iconName)
    }));
  }
  if (library === iconLibraries.Fisherman) {
    var SvgIcon = getFishermanIcon(iconName);
    return /*#__PURE__*/React.createElement(SemanticIcon, _extends({
      className: finalClassName
    }, iconProps), /*#__PURE__*/React.createElement(SvgIcon, null));
  }
  return null;
}
Icon.defaultProps = defaultProps;